<p-card>
  <div class="flex justify-content-between align-items-center p-2 bg-blue-50">
    <span class="text-xl font-semibold">Document Viewer</span>
    <p-chip styleClass="font-semibold" [label]="documentName" />
    <p-button
      label="Download"
      icon="pi pi-download"
      severity="secondary"
      (click)="downloadDocument()"
    />
  </div>
  @if (showErrorMessage) {
    <div
      class="flex justify-content-center align-items-center text-2xl content-height"
    >
      Looks like the document you are looking for is not available!
    </div>
  } @else {
    <div
      class="html-content-wrapper overflow-y-scroll block z-0 content-height"
      [innerHTML]="htmlContent"
    ></div>
  }
  <ng-template pTemplate="footer">
    <div class="bg-blue-50">
      <via-footer></via-footer>
    </div>
  </ng-template>
</p-card>
